<template>
  <div>
    <p>
      {{ $t('check') }}
    </p>
    <ol>
      <li>
        <p>
          {{ $t('p1') }}
        </p>
      </li>
      <li>
        <p>
          {{ $t('p2') }} {{ $t('goToStart') }} <mdicon name="windows" /> → {{ $t('parameters') }}  <img v-if="image" :src="image" style="width:3%;height:2%;" class="error-image" alt=""> → {{ $t('privacy') }} <mdicon name="lock-outline" /> → {{ $t('cameraAndSure') }}
        </p>
        <ul>
          <li>
            {{ $t('a') }}
          </li>
          <li>
            {{ $t('b') }}
          </li>
          <li>
            {{ $t('c') }}
          </li>
          <li>
            {{ $t('d') }}
          </li>
        </ul>
      </li>
    </ol>
    <br>
    <p>
      {{ $t('more') }} <a target="_blank" href="https://support.microsoft.com/windows/a83257bc-e990-d54a-d212-b5e41beba857">{{ $t('support') }}</a>.
    </p>
  </div>
</template>

<script>
import { mdiWindows, mdiLockOutline } from '@mdi/js';
import cogOutlineImage from '../../../assets/img/cog-outline.png';

export default {
  name: 'NotReadableErrorVideoWindows',
  computed: {
    image() {
      return cogOutlineImage;
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
check: 'Unable to access your camera. There are two possible reasons:'
p1: 'Your camera is currently being used by another application (such as Skype or Zoom). Usually, the indicator on the camera will light up. Close all other applications that might be using your camera and then reload the page.'
p2: If you are sure that the camera is not currently in use, then access to it is denied in the privacy settings of Windows 10.
goToStart: Go to Start
parameters: Settings
privacy: Privacy
cameraAndSure: 'Camera and make sure that:'
a: Camera access for this device is enabled;
b: '"Allow apps to access the camera" is set to "On";'
c: '"Allow desktop apps to access camera" (if any) is set to "On";'
d: After making any changes to Settings, refresh the page.
more: Learn more on the
support: Microsoft Support site
</i18n>

<i18n locale="ru" lang="yaml">
check: 'Невозможно получить доступ к камере. Возможные причины:'
p1: Камера сейчас используется другим приложением (например, Skype или Zoom). Обычно при этом на камере горит индикатор. Закройте все приложения, которые могут использовать камеру, после чего перезагрузите страницу.
p2: Если вы уверены, что камера сейчас не используется, значит доступ к ней запрещён в настройках конфиденциальности Windows 10.
goToStart: Перейдите Пуск
parameters: Параметры
privacy: Конфиденциальность
cameraAndSure: 'Камера и убедитесь, что:'
a: Доступ к камере для этого устройства включен;
b: «Разрешить приложениям доступ к камере» находится в положении «Вкл.»;
c: «Разрешить классическим приложениям доступ к камере» (если есть) находится в положении «Вкл.»;
d: После внесения изменений в Настройки обновите страницу.
more: Подробнее на сайте
support: поддержки Microsoft
</i18n>
